import ApiService from "@/core/services/api.service";
// action types
export const GET_TIPO_DOCUMENTOS = "getTipoDocumentos";

// mutation types
export const SET_TIPO_DOCUMENTOS = "setTipoDocumentos";


export const SET_ERROR = "setError";

const state = {
  errors: [],
  tipoDocumentos: [],

};

const actions = {
  [GET_TIPO_DOCUMENTOS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/api/TipoDocumento/v1/tiposDocumento`}, '')
        .then(({ data }) => {
            console.log(JSON.stringify(data));
          context.commit(SET_TIPO_DOCUMENTOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  

};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_TIPO_DOCUMENTOS](state, data) {
    state.error = {};
    state.tipoDocumentos = data;
  },

};

export default {
  state,
  actions,
  mutations
};
